import axios from 'axios';
import type { DomainHealthResult } from '@/services/deployment/deployment.service';

/** Pull a human-readable message out of an axios error. */
export function extractMessage(err: unknown, fallback: string): string {
    if (axios.isAxiosError(err)) {
        const data = err.response?.data as
            | { message?: string | string[] }
            | undefined;
        if (data?.message) {
            return Array.isArray(data.message) ? data.message.join(', ') : data.message;
        }
    }
    if (err instanceof Error) return err.message;
    return fallback;
}

/** The per-domain report a 422 from the deploy endpoint carries. */
export function extractHealthReport(err: unknown): DomainHealthResult[] | null {
    if (axios.isAxiosError(err)) {
        const data = err.response?.data as
            | { healthReport?: DomainHealthResult[] }
            | undefined;
        if (Array.isArray(data?.healthReport)) return data.healthReport;
    }
    return null;
}
